import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import Login from "@/pages/Login";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import Overview from "@/pages/admin/Overview";
import ExcelImport from "@/pages/admin/ExcelImport";
import Students from "@/pages/admin/Students";
import Parents from "@/pages/admin/Parents";
import Trainers from "@/pages/admin/Trainers";
import Classes from "@/pages/admin/Classes";
import Search from "@/pages/admin/Search";
import Report from "@/pages/admin/Report";
import AdminMessages from "@/pages/admin/AdminMessages";
import StudentDashboard from "@/pages/StudentDashboard";
import ParentDashboard from "@/pages/ParentDashboard";
import TrainerDashboard from "@/pages/TrainerDashboard";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import Performance from "@/pages/student/Performance";
import Leaderboard from "@/pages/student/Leaderboard";
import ParentPerformance from "@/pages/parent/Performance";
import TrainerTopics from "@/pages/trainer/TrainerTopics";
import TopicForm from "@/pages/trainer/TopicForm";
import TrainerClassStudents from "@/pages/trainer/TrainerClassStudents";
import TopicView from "@/pages/TopicView";
import SectionTopics from "@/pages/student/SectionTopics";
import { Toaster } from "sonner";

function RoleRedirect() {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">جاري التحميل...</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (user.must_change_password) return <Navigate to="/change-password" replace />;
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "trainer") return <Navigate to="/trainer" replace />;
    if (user.role === "student") return <Navigate to="/student" replace />;
    if (user.role === "parent") return <Navigate to="/parent" replace />;
    return <Navigate to="/login" replace />;
}

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-center" richColors dir="rtl" />
                    <Routes>
                        <Route path="/" element={<RoleRedirect />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/change-password" element={<ForcePasswordChange />} />

                        <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminLayout /></ProtectedRoute>}>
                            <Route index element={<Overview />} />
                            <Route path="import" element={<ExcelImport />} />
                            <Route path="students" element={<Students />} />
                            <Route path="parents" element={<Parents />} />
                            <Route path="trainers" element={<Trainers />} />
                            <Route path="classes" element={<Classes />} />
                            <Route path="search" element={<Search />} />
                            <Route path="messages" element={<AdminMessages />} />
                            <Route path="report" element={<Report />} />
                        </Route>

                        <Route path="/student" element={<ProtectedRoute roles={["student"]}><StudentDashboard /></ProtectedRoute>} />
                        <Route path="/student/performance" element={<ProtectedRoute roles={["student"]}><Performance /></ProtectedRoute>} />
                        <Route path="/student/leaderboard" element={<ProtectedRoute roles={["student"]}><Leaderboard /></ProtectedRoute>} />
                        <Route path="/parent/leaderboard" element={<ProtectedRoute roles={["parent"]}><Leaderboard /></ProtectedRoute>} />
                        <Route path="/student/section/:section" element={<ProtectedRoute roles={["student", "parent"]}><SectionTopics /></ProtectedRoute>} />
                        <Route path="/student/topic/:id" element={<ProtectedRoute roles={["student", "parent"]}><TopicView /></ProtectedRoute>} />
                        <Route path="/parent" element={<ProtectedRoute roles={["parent"]}><ParentDashboard /></ProtectedRoute>} />
                        <Route path="/parent/performance" element={<ProtectedRoute roles={["parent"]}><ParentPerformance /></ProtectedRoute>} />
                        <Route path="/trainer" element={<ProtectedRoute roles={["trainer"]}><TrainerDashboard /></ProtectedRoute>} />
                        <Route path="/trainer/topics" element={<ProtectedRoute roles={["trainer"]}><TrainerTopics /></ProtectedRoute>} />
                        <Route path="/trainer/topics/new" element={<ProtectedRoute roles={["trainer"]}><TopicForm /></ProtectedRoute>} />
                        <Route path="/trainer/topics/:id/edit" element={<ProtectedRoute roles={["trainer"]}><TopicForm /></ProtectedRoute>} />
                        <Route path="/trainer/topic/:id" element={<ProtectedRoute roles={["trainer"]}><TopicView /></ProtectedRoute>} />
                        <Route path="/trainer/class/:id" element={<ProtectedRoute roles={["trainer"]}><TrainerClassStudents /></ProtectedRoute>} />
                        <Route path="/messages" element={<ProtectedRoute roles={["student", "parent", "trainer"]}><Messages /></ProtectedRoute>} />
                        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}
